var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C4.475 20 0 15.525 0 10C0 4.475 4.475 0 10 0C15.525 0 20 4.475 20 10C20 15.525 15.525 20 10 20Z",
    fill: "#F81C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.994 6.24926C14.994 5.56217 14.4319 5 13.7447 5C13.395 5 13.0827 5.13742 12.8578 5.36228L9.997 8.23557L7.13622 5.37477C6.91136 5.13742 6.59905 5 6.24926 5C5.56217 5 5 5.56217 5 6.24926C5 6.59905 5.13742 6.91136 5.36228 7.13622L8.22307 9.997L5.36228 12.8578C5.13742 13.0827 5 13.395 5 13.7447C5 14.4319 5.56217 14.994 6.24926 14.994C6.59905 14.994 6.91136 14.8566 7.13622 14.6317L9.997 11.771L12.8578 14.6317C13.0827 14.8566 13.395 14.994 13.7447 14.994C14.4319 14.994 14.994 14.4319 14.994 13.7447C14.994 13.395 14.8566 13.0827 14.6317 12.8578L11.771 9.997L14.6317 7.13622C14.8566 6.91136 14.994 6.59905 14.994 6.24926Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.928c026ca4ec1defff6f158a8f424f50.svg";
export { ForwardRef as ReactComponent };